import React,{useState, useEffect} from 'react';
import $ from 'jquery'; 

import {
    Row,
    Col,      
    Button,
    InputGroup,
    Form,
    Alert,
    FormControl
} from 'react-bootstrap';

import {Uploader, RTEditor} from '../../components';
import axios from 'axios';
import Utils from './../../Utils';
import _ from 'lodash';

const defaultQuesStruct = (data) => {
    var def = {        
        question    : '',    
        description : '',
        type        : 0,
        answers     : ['','','',''],
        explanations: ['', '', '', ''],
        correct     : [0],
        countable   : true,
        feedback    : true,
    };
    return {...def,...data};
}

const QuestionForm = (props) => {

    const isEdit = () => {
        return _.get(props,'mode',0);
    };

    const [question,setQuestion] = useState(defaultQuesStruct(props.data));
    const [audio, setAudio] = useState(_.get(props,'data.audio', ''));


    function setLabelForRadioCheckbox() {
        $('input[type=checkbox] ~ label').remove();
        $('input[type=radio] ~ label').remove();
        $('input[type=checkbox]').each(function() {
            var id = $(this).attr('id');
            $('<label for="'+id+'"></label>').insertAfter(this);
        })
        $('input[type=radio]').each(function() {
            var id = $(this).attr('id');
            $('<label for="'+id+'"></label>').insertAfter(this);
        })
    }
    
    useEffect(() => {
        setLabelForRadioCheckbox();
        
        
    }, [question.type]);

    const finalizeQuestion = () => {
        if(question.correct[0] === "" || question.correct[0] === undefined){
            alert("Please select correct answer");
            return;
        }
        question['audio'] = audio;
        props.onFinalize(question,'Question',isEdit());
    }

    const removeAudio = () => {    
        if(window.confirm('This will remove the audio file.. continue?')){
            axios.delete(Utils.apiUrl('delfile?file=' + audio), Utils.apiHeaders());
            setAudio('');
        }
      }

    const getCorrectValue = (frm) => {
        const tp = parseInt(frm.type.value);
        if(tp===0){
            return [frm.correct.value];
        }else{
            var tmp = [];
            for(var opts = 0; _.get(frm,`correct_${opts}`,false)!==false; opts++){
                if(frm[`correct_${opts}`].checked){
                    tmp.push(parseInt(frm[`correct_${opts}`].value));
                }
            }
            return tmp;
        }
    }

    const onQuestionSubmit = (e) => {        
        e.preventDefault();
        onQuestionSave(e.currentTarget);
    }

    const onQuestionChange = (e) => {        
        onQuestionSave(e.currentTarget.form);
    } 

    const onFeedbackChange = (e) => {        
        onQuestionSave(e.currentTarget.form);
    }

    const setDesc = (questionDesc) => {        
        if(typeof(questionDesc) === "object"){
            let tmp = {...question};
            tmp.explanations[questionDesc.id]= questionDesc.expl;
            setQuestion(tmp)            
        }else{
            setQuestion({...question,description: questionDesc});
        }        
    }

    const onQuestionSave = (frm) => {
        var ques = {            
            type        : parseInt(frm.type.value),
            question    :  frm.question.value,
            description : frm.description.value,
            answers     : [],
            explanations: [],
            correct     : getCorrectValue(frm),
            countable   : frm.countable.checked,
            feedback    : frm.feedback.checked 
        };

        for(var opts = 0; _.get(frm,`anstxt_${opts}`,false)!==false; opts++){
            ques['answers'].push(frm[`anstxt_${opts}`].value);
        }
            for(var explns = 0; question.explanations[explns]; explns++){
                ques['explanations'].push(question.explanations[explns]);
            }
        
        setQuestion(ques);
    }

    const setQuestionType = (e) => {
        setQuestion({...question,type: parseInt(e.currentTarget.value)});
    }

    const addMoreOption = (e) => {
        var tmp = {...question};
        tmp.answers.push('');
        tmp.explanations.push('');
        setQuestion(tmp);
        setTimeout(function() {
            setLabelForRadioCheckbox();
        }, 100)
    }

    const removeAnswer = (e) => {
        const aidx = parseInt(e.currentTarget.getAttribute('aid'));                
        var tmp = {...question};
        _.remove(tmp.answers,(a,anidx) => anidx===aidx);        
        _.remove(tmp.explanations,(a,anidx) => anidx===aidx);   
        setQuestion(tmp);
    }

    const renderQuestionForm = (q) => {
        return <Form onSubmit={onQuestionSubmit} className="addQuestion">                 
            <InputGroup className="mb-3">
                <InputGroup.Prepend><InputGroup.Text className="quesLabel">Question Title: </InputGroup.Text></InputGroup.Prepend>
                <FormControl
                    onChange={onQuestionChange}
                    name="question"
                    placeholder="Enter your Question Title"
                    defaultValue={q.question}
                    aria-label="Question"
                />
            </InputGroup>
            <InputGroup className="mb-3">
                <InputGroup.Prepend><InputGroup.Text className="quesLabel">Question: </InputGroup.Text>
                </InputGroup.Prepend>
                <span 
                className="w-100 text-left">
                <RTEditor 
                as="textarea"
                rows={6}
                name="description" 
                srcType="video"
                setDesc={setDesc}
                value={q.description}
                aria-label="Question"
                placeholder="Enter your Question" /></span>
            </InputGroup>
            
            <InputGroup className="mb-3 type">
                <InputGroup.Prepend><InputGroup.Text className="quesLabel">Type: </InputGroup.Text></InputGroup.Prepend>
                <FormControl as="select" onChange={setQuestionType} defaultValue={q.type} name="type">
                    {Utils.questionType.map((qt,qtidx) => <option key={qtidx} value={qtidx}>{qt}</option>)}                    
                </FormControl>
            </InputGroup>

            <Alert variant="info">Please select the right answer for scorm to track the correct answer.</Alert>

            <InputGroup className="mb-3 correctness">
                <InputGroup.Prepend>
                    
                    <InputGroup.Checkbox id="countable" name="countable" onClick={onQuestionChange} defaultChecked={q.countable} />
                    
                </InputGroup.Prepend>
                <FormControl readOnly placeholder="Correctness of this question will impact your score." />
            </InputGroup>
             <InputGroup className="mb-3 correctness">
                <InputGroup.Prepend>                    
                    <InputGroup.Checkbox id="feedback" name="feedback" onClick={onFeedbackChange} defaultChecked={q.feedback} />                    
                </InputGroup.Prepend>
                <FormControl readOnly placeholder="Dispaly feedback after submitting question." />
            </InputGroup>

            <div className="queans">
            {q.answers.map((a,aidx) => <InputGroup key={aidx} id={aidx} className="mb-3">
                <InputGroup.Prepend>
                    {q.type===0 &&<>                         
                            <InputGroup.Radio id={`radio_${aidx}`} name={`correct`} onClick={onQuestionChange} 
                                    defaultChecked={q.correct.includes(String(aidx))} value={aidx} 
                            />
                            
                        </>
                    }
                    {q.type===1 && <>                         
                        <InputGroup.Checkbox id={`checkbox_${aidx}`} name={`correct_${aidx}`} onClick={onQuestionChange} defaultChecked={q.correct.includes(aidx)} value={aidx} />                        
                    </>
                    }
                    
                </InputGroup.Prepend>
                    
                <FormControl name={`anstxt_${aidx}`} onChange={onQuestionChange} placeholder={`Option ${aidx+1}`} value={q.answers[aidx]} />
                {aidx > 1 && <InputGroup.Append>
                    <Button size="sm" variant="danger" aid={aidx} title="Remove Option" onClick={removeAnswer}>X</Button>
                </InputGroup.Append>}
                
                <span 
                    className="w-100 text-left">
                        <br />
                <InputGroup.Prepend><InputGroup.Text className="quesLabel">Explanation: </InputGroup.Text>
                </InputGroup.Prepend>
                        <RTEditor 
                            as="textarea"
                            rows={6}
                            name={`expln_${aidx}`} 
                            // srcType="Video"
                            setDesc={setDesc}
                            idx={aidx}
                            value={`${q.explanations[aidx]}`}
                            aria-label="Question"
                            placeholder={`Enter Explanation for Option ${aidx+1}`}
                        />                        
                </span>       
            </InputGroup>)}
            </div>

            <Row className="addMoreOpt">
                <Col sm={12} className="text-center">
                {q.answers.length < 6 && <Button size="sm" variant="success" title="Add Option" onClick={addMoreOption}>+</Button>}
                </Col>
            </Row>
        </Form>;
    }

    return <>  
    <div className="popcotentpad">
        <Row className="m-2 text-center">
            <Col sm={12}>{renderQuestionForm(question)}</Col>
        </Row>
        <Row className="mx-2">
            <Col sm={1} className="text-left"><i className="icon aud"></i></Col>
            {audio==='' && <>
                <Col sm={11} className="text-left" style={{minHeight: '150px', maxHeight: '150px', overflow: 'auto'}}>
                    <Uploader accept="audio/*" uploadUrl={Utils.apiUrl('saveupload')} onUpload={setAudio} />
                </Col>     
            </>}    
            {audio!=='' && <>
                <Col sm={11}>
                    <audio controls>      
                        <source src={Utils.apiUrl(`file?f=${audio}`)} type="audio/mpeg" />
                        Your browser does not support the audio element.
                    </audio>
                    <span className="fa fa-2x fa-trash text-primary clickable ml-3 mt-2 position-absolute" title="Remove Audio" onClick={removeAudio} />
                </Col>
            </>}
        </Row>

        <Row className="m-2 text-center mb80">
            <Col sm={12}>
                <img src={`${process.env.PUBLIC_URL}/images/upload-quizz_button.png`} className="clickable mx-2" alt="finalize Quiz" onClick={finalizeQuestion} />                
            </Col>
        </Row>
        </div>
    </>;
}

export default QuestionForm;